module.exports = __webpack_public_path__ + "media/src/assets/Images/OurHistoryImage-b1af2a7cc2f019a0e6f8f971a2ce7fe2.svg";